/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import { Action, Store } from "@byhuz/huz-ui-state";
import { Redirect } from "react-router-dom";

// components

export default function Navbar(props) {
    const [navbarOpen, setNavbarOpen] = React.useState(false);
    const [redirectChangePassword, setRedirectChangePassword] = React.useState(false); 
    const state=useSelector(state=>state.default);    

    const onLogout = (e) => {
        e.preventDefault();
        axios.get('logoff')
        .then(res=>{
          console.log("Logout");
          Store.dispatch(Action.update("loggedIn", false));
          return <Redirect to={{
            pathname: '/mapcodes'
          }} />;
        })
        .catch(err=>{
          console.log(err);
        })
    }

    const onChangePassword = (e) => {
      setRedirectChangePassword(true);
    }

    if (redirectChangePassword){
      console.log("Redirect to Change Password");
      return <Redirect to={{
        pathname: '/auth/changepassword'
      }} />;
    }

  return (
    <>
      <nav className="top-0 absolute z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg">
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <Link
              className="text-white text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-no-wrap uppercase"
              to="/"
            >
              MB NaviCodes
            </Link>
            <button
              className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className="text-white fas fa-bars"></i>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center bg-white lg:bg-transparent lg:shadow-none" +
              (navbarOpen ? " block rounded shadow-lg" : " hidden")
            }
            id="example-navbar-warning"
          >
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
              <li className="flex items-center">
                <button
                  className="bg-white text-gray-800 active:bg-gray-100 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150"
                  type="button"
                  onClick={
                    () => window.open('https://mega.nz/file/fl11ASJZ#tw8-6XnnYjiEiDl6tOXcaaeAW2_kDhKCpS9JNJyLZsA', '_blank', 'noopener')
                  }
                >
                  <i className="fas fa-arrow-alt-circle-down"></i> Download Map Data
                </button>
              </li>
              {state?.loggedIn!=true?
              <>
              <li className="flex items-center">                
                <Link to="/auth/login" className="bg-white text-gray-800 active:bg-gray-100 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150">Login
                </Link>
              </li>
              <li className="flex items-center">                
                <Link to="/auth/register" className="bg-white text-gray-800 active:bg-gray-100 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150">Register
                </Link>
              </li>
              </>
            :
              <>
              <li className="flex items-center">                
                <button 
                  onClick={e=> onLogout(e)}
                  type="button"
                  className="bg-white text-gray-800 active:bg-gray-100 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150">Logout
                </button>
              </li>
              <li className="flex items-center">                
              <button 
                onClick={e=> onChangePassword(e)}
                type="button"
                className="bg-white text-gray-800 active:bg-gray-100 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150">Change Password
              </button>
              </li>
              <li className="flex items-center">                
                <Link to="/admin/history" className="bg-white text-gray-800 active:bg-gray-100 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150">History
                </Link>
              </li>
              <li className="flex items-center">                
                <Link to="/admin/transaction" className="bg-white text-gray-800 active:bg-gray-100 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150">Transaction
                </Link>
              </li>
              </>
            }
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
